import { useTranslation } from 'react-i18next';

import ButtonDemo from '../button'
import style from './styles.module.scss'
import logoName from '../../../assets/logos/logo_nexora.svg'
import handPhone from '../../../assets/hand_phone.png'

export function Hero() {
    const { t } = useTranslation();

    return (
        <section id='product' className={`container ${style['hero']}`}>
            <div className={style["hero__title"]}>
                <h1>
                    {t('hero.title.before')}{' '}
                    <span className='accent'>
                        {t('hero.title.accent')}
                    </span>{' '}
                    {t('hero.title.after')}
                </h1>
                <div className={style['hero__description']}>
                    <p>{t('hero.description')}</p>

                    <ButtonDemo
                        size='large'
                        directIcon
                    >
                        {t('hero.button')}
                    </ButtonDemo>
                </div>
            </div>

            <div className={style["hero__banner"]}>
                <div className={style['hero__banner-bg']}>
                    <img
                        className={style['hero__banner-namelg']}
                        src={logoName}
                        alt=""
                    />
                </div>

                <img
                    className={style['hero__banner-handph']}
                    src={handPhone}
                    alt="Logo"
                />
            </div>
        </section>
    )
}